/* eslint-disable */
<template lang="html">
  <div class="ai-image-upload"
       :style="style"
       :draggable="false"
       @click="onClick">
    <div v-if="!imagePreviewing && !imageUrl" class="ai-image-upload__info">
      <img src="./plus.png" class="ai-image-upload__plus" :style="iconStyle">
      <span class="ai-image-upload__text" :style="textStyle">{{ text }}</span>
      <span v-if="sub && sub.length"
            class="ai-image-upload__text ai-image-upload__text--sub">
        {{ sub }}
      </span>
    </div>
    <div v-else class="ai-image-upload__preview" :draggable="false">
      <img v-if="imagePreviewing" :src="imagePreviewing" class="ai-image-upload__image">
      <img v-else
           :src="imageUrl"
           class="ai-image-upload__image"
           :draggable="false">
    </div>
    <input ref="uploader"
           type="file"
           class="ai-image-upload__input"
           :accept="accept"
           @change="previewImage">
  </div>
</template>

<script>
export default {
  name: 'AiImageUpload',
  props: {
    text: { type: String, default: '上传文件' },
    sub: { type: String, default: '' },
    accept: { type: String, default: 'image/*' },
    imageUrl: { type: String, default: null },
    width2: { type: String, default: '100px' },
    height: { type: String, default: '100px' },
    size: { type: String, default: 'normal' }, /* eslint-disable */ 
    filesize: 0 
  },
  data: () => ({
    imagePreviewing: null
  }),
  computed: {
    style() {
      const style = {};
      if (this.width) {
        style.width = Number.isNaN(Number(this.width)) ? this.width : `${Number(this.width)}px`;
      }
      if (this.height) {
        style.height = Number.isNaN(Number(this.height)) ? this.height : `${Number(this.height)}px`;
      }
      return style;
    },
    iconStyle() {
      const style = {};
      if (this.size === 'small') {
        style.width = '18px';
        style.height = '18px';
        style.margin = '12px 0 8px';
      }
      return style;
    },
    textStyle() {
      const style = {};
      if (this.size === 'small') {
        style['font-size'] = '10px';
      }
      return style;
    }
  },
  watch: {
    imagePreviewing(val) {
      if (!val) this.$emit('change', '');
      else this.$emit('change', val);
    }
  },
  methods: {
    onClick() {
      this.$refs.uploader.click();
    },
    previewImage() {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        this.imagePreviewing = fileReader.result;
        const thethis = this; /* eslint-disable */
        const image = new Image();
        image.src = fileReader.result;// eslint-disable-next-line
        image.onload = function() {
          thethis.$emit('imagescale', this.width / this.height);
        }/* eslint-disable */
      }, false);
      const file = this.$refs.uploader.files[0];     /* eslint-disable */
      if (file) {
        fileReader.readAsDataURL(file);
        this.$emit('filesize', file.size);
      } else this.imagePreviewing = null;
    },
    getImageData() {
      return this.imagePreviewing;
    },
    clear() {
      this.imagePreviewing = null;
    }
  }
};
</script>
